import { z } from 'zod';
import { OrderSchema } from '../order';

const schema = OrderSchema.model;
export const locationTrackingOrderSchema = schema.pick({
  _id: true,
  ref: true,
});
export type LocationTrackingOrder = z.infer<typeof locationTrackingOrderSchema>;
